import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getEnergyStatistics} from '@apis'
import {registerShape} from '@antv/g2'
import Chart from '@components/chart'
import ChartBlock from '@components/chartBlock'

function creatTestData() {
  const data = [];
  const val = (Math.random() * 6).toFixed(1);
  data.push({value: +val});
  return data;
}

const EnergyConsumption = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {strongProjectId: projectId} = userInfo
    const [energyConsumptionChartData, setEnergyConsumptionChartData] = useState([])
    const [energyConsumption, setEnergyConsumption] = useState(0)

    // 查询能耗
    async function queryEnergyData() {
      const params = {
        dimension: 3,
        projectId
      }
      const res = await getEnergyStatistics(params)
      if (res) {
        setEnergyConsumptionChartData([{value: +res.yearTotal}])
        setEnergyConsumption((res.yearTotal).toFixed(2))
      }
    }

    useEffect(() => {
      queryEnergyData()
    }, [])

    const renderChart = (instance, opts) => {
      let count = 0
      for(let i=0; i<opts.data.length; i++) {
        if(count < opts.data[0].value) {
          count = parseInt(opts.data[0].value/100) + 1
        }
      }
      registerShape('point', 'pointer', {
        draw(cfg, container) {
          const group = container.addGroup({});
          // 获取极坐标系下画布中心点
          const center = this.parsePoint({x: 0, y: 0});
          // 绘制指针
          group.addShape('line', {
            attrs: {
              x1: center.x,
              y1: center.y,
              x2: cfg.x,
              y2: cfg.y,
              stroke: cfg.color,
              lineWidth: 5,
              lineCap: 'round',
            },
          });
          group.addShape('circle', {
            attrs: {
              x: center.x,
              y: center.y,
              r: 9.75,
              stroke: cfg.color,
              lineWidth: 4.5,
              fill: '#fff',
            },
          });
      
          return group;
        },
      });
      const color = ['#00EEE0', '#0595FF', '#FF9600'];
      instance.data(opts.data);
      instance.animate(false);

      instance.coordinate('polar', {
        startAngle: (-9 / 8) * Math.PI,
        endAngle: (1 / 8) * Math.PI,
        radius: 0.75,
      });
      instance.scale('value', {
        min: 0,
        max: count*100,
        tickInterval: 100,
      });

      instance.axis('1', false);
      instance.axis('value', {
        line: null,
        label: {
          offset: -40,
          style: {
            fontSize: 18,
            fill: '#CBCBCB',
            textAlign: 'center',
            textBaseline: 'middle',
          },
        },
        tickLine: {
          length: -20,
        },
        grid: null,
      });
      instance.legend(false);
      instance.tooltip(false);
      instance
        .point()
        .position('value*1')
        .shape('pointer')
        .color('value', (val) => {
          if (val < 100) {
            return color[0];
          } else if (val <= 300) {
            return color[1];
          } else if (val <= 500) {
            return color[2];
          }
          return color[2];
        });

      draw(opts.data);

      function draw(data) {
        const val = data[0].value;
        const lineWidth = 20;
        instance.annotation().clear(true);
        // 绘制仪表盘背景
        instance.annotation().arc({
          top: false,
          start: [0, 1],
          end: [count*100, 1],
          style: {
            stroke: '#CBCBCB',
            lineWidth,
            lineDash: null,
          },
        });

        if (val >= 200) {
          instance.annotation().arc({
            start: [0, 1],
            end: [val, 1],
            style: {
              stroke: color[0],
              lineWidth,
              lineDash: null,
            },
          });
        }

        if (val >= 400) {
          instance.annotation().arc({
            start: [2, 1],
            end: [4, 1],
            style: {
              stroke: color[1],
              lineWidth,
              lineDash: null,
            },
          });
        }

        if (val > 400 && val <= 600) {
          instance.annotation().arc({
            start: [4, 1],
            end: [val, 1],
            style: {
              stroke: color[2],
              lineWidth,
              lineDash: null,
            },
          });
        }

        if (val > 200 && val <= 400) {
          instance.annotation().arc({
            start: [2, 1],
            end: [val, 1],
            style: {
              stroke: color[1],
              lineWidth,
              lineDash: null,
            },
          });
        }

        if (val < 200) {
          instance.annotation().arc({
            start: [0, 1],
            end: [val, 1],
            style: {
              stroke: color[0],
              lineWidth,
              lineDash: null,
            },
          });
        }

        // 绘制指标数字
        instance.annotation().text({
          position: ['50%', '90%'],
          content: 'kwh',
          style: {
            fontSize: 20,
            fill: '#01F7FD',
            textAlign: 'center',
          },
        });
        // instance.annotation().text({
        //   position: ['50%', '88%'],
        //   content: `总能耗: ${Math.round(data[0].value*100)/100}kwh`,
        //   style: {
        //     fontSize: 20,
        //     fill: '#01F7FD',
        //     textAlign: 'center',
        //   },
        //   offsetY: 15,
        // });
        instance.changeData(data);
      }
    }
    return (
      <ChartBlock title="总能耗">
        {
          energyConsumptionChartData.length ? (
            <Chart renderChart={renderChart} style={{height: '90%'}} data={energyConsumptionChartData} />
          ) : null
        }
        <div style={{color: '#01f4fb', fontSize: '20px', textAlign: 'center'}}>总能耗：{energyConsumption}kwh</div>
      </ChartBlock>
    ) 
  })
)

export default EnergyConsumption
